{
  "checkout": {
    "title": "Def sa komand",
    "cart_summary": "{{count}} produwe ci paañe bi",
    "cart_summary_plural": "{{count}} produwe ci paañe bi",

    "tva": "TVA (18%)",
    "delivery_fee": "Njërëmi yónnee",
    "service_fee": "Njërëmi service",
    "total": "Total",
    "cart_item": "{{count}} produwe ci paañe bi",
    "cart_item_plural": "{{count}} produwe ci paañe bi",

    "steps": {
      "info": "Xibaar yi",
      "payment": "Fey",
      "confirmation": "Dëggal",
      "aria_label": "Etap yi komand bi"
    },

    "info": {
      "title": "Sa xibaar yi",
      "subtitle": "Dugal sa xibaar yi ngir indil bi. Soxluloo kont.",
      "full_name_label": "Tur bu mat",
      "full_name_placeholder": "Abdou Diallo",
      "phone_label": "Telefon *",
      "email_label": "E-mail (du waajib)",
      "address_label": "Adres bu mat *",
      "address_placeholder": "Nimero, mbedd, kër / appartement",
      "quartier_label": "Kërgi *",
      "quartier_placeholder": "Mel ni : Hann Mariste",
      "commune_label": "Komiin *",
      "commune_placeholder": "Mel ni : Hann Bel-Air",
      "region_label": "Régioon *",
      "region_placeholder": "Tànnal sa régioon",
      "privacy_prefix": "Nangu naa",
      "privacy_link": "politig suturlu",
      "privacy_suffix": "Djayma",
      "continue": "Kontine"
    },

    "validation": {
      "name_required": "Tur bu mat war na am lu tolluwul 2 karakteer",
      "phone_invalid": "Nimero telefon war na am format Senegaal (+221 XX XXX XX XX).",
      "email_invalid": "Adres e-mail bi baaxul.",
      "address_required": "Adres bi war na am",
      "quartier_required": "Kërgi war na am",
      "commune_required": "Komiin bi war na am",
      "region_required": "Tànnal ab régioon",
      "privacy_required": "War nga nangu politig suturlu bi ngir kontine.",
      "required": "Biir bii war na am"
    },

    "payment": {
      "title": "Naka ngay fey",
      "subtitle": "Tànn naka ngay fey sa komand.",
      "wave": "Wave",
      "wave_description": "Fey ci telefon ak Wave",
      "orange_money": "Orange Money",
      "orange_money_description": "Fey ci telefon ak Orange Money",
      "cash": "Fey ci jëlëg",
      "cash_description": "Fey ci xaalis bu ñu la indil sa komand",
      "phone_label": "Nimero {{provider}} *",
      "instructions": "Dinga jot ñaan fey ci nimero bii.",
      "total_label": "Tollu bu war fey",
      "back": "Dellu",
      "confirm": "Dëggal fey bi",
      "cod_ineligible": {
        "max_amount": "Fey ci jëlëg amul ngir komand yi tollu ëpp {{amount}}.",
        "min_amount": "Fey ci jëlëg am na ci {{amount}}.",
        "zone_restricted": "Fey ci jëlëg amul ci sa zone indil.",
        "max_pending": "Tëbaleel na tollu bu mëna am komand yi xaar ak fey ci jëlëg.",
        "cod_disabled": "Fey ci jëlëg mënuñu ko def léegi.",
        "default": "Fey ci jëlëg amul ngir komand bii."
      }
    },

    "confirm_modal": {
      "title": "Dëggal fey bi",
      "subtitle": "Xool détay yi ci kanam",
      "amount_label": "Xaalis bi war fey",
      "method_label": "Yoon fey",
      "phone_label": "Nimero telefon",
      "cod_notice": "Fey bi dinga ko def ci xaalis bu ñu la indil sa komand.",
      "mobile_money_notice": "Dinga jot ñaan fey {{provider}} ci sa telefon. Dëggalal ko ngir dooleel sa komand.",
      "cancel": "Neenal",
      "pay_now": "Fey {{amount}}",
      "processing": "Ci kanam..."
    },

    "polling": {
      "waiting": "Di ngantu dëggal {{provider}}...",
      "waiting_description": "Dëggalal fey bi ci sa telefon. Xàtt bii dina ko yéegal boppam.",
      "confirmed": "Fey bi dëgg na!",
      "confirmed_description": "Sa fey bi ci {{provider}} agsi na ak jàmm.",
      "timeout": "Fey bi agsi wul",
      "timeout_description": "Jotuwuñu dëggal sa fey bi {{provider}} ci waxtu bi.",
      "failed": "Fey bi jotul",
      "failed_message": "Fey bi jotul. Jéemal ko.",
      "failed_generic": "Fey bi ci {{provider}} jotul.",
      "retry": "Jéemal ko"
    },

    "confirmation": {
      "success": "Komand bi dëgg na!",
      "reference": "Sa référence komand :",
      "summary": "Tënk bi",
      "subtotal_ht": "Tollu HT",
      "tva": "TVA (18 %)",
      "delivery": "Njëg indil",
      "total_ttc": "Tollu TTC",
      "delivery_address": "Adres indil",
      "payment": "Fey",
      "whatsapp_confirm": "Dëggal komand bi ci WhatsApp",
      "track_order": "Topp sama komand",
      "back_home": "Dellu ci dallu bi"
    },

    "post_checkout": {
      "title": "Bëgg nga jàpp ëpp?",
      "create_account_prompt": "Sos ab kont ngir am rabais ci sa jënd yi ci topp! Gis itam limu sa jënd yi ak sa adres yi.",
      "create_account_button": "Sos sama kont",
      "dismiss": "Déedéet, ginnaaw"
    },

    "errors": {
      "price_changed": "Prix yi soppi nañu. Yéegalal sa paañe.",
      "network": "Njuumte réseau. Xoolal sa connexion.",
      "order_failed": "Am na njuumte ci sosaat sa komand. Jéemal ko."
    },

    "delivery": {
      "title": "Sa adres indil",
      "error_loading_zones": "Mënuñu yéegal zone indil yi. Jéemal ko.",
      "retry": "Jéemal ko",
      "no_zones": "Amul zone indil ci waxtu bii.",
      "contact_us": "Wàccal ñu ci {{phone}} ngir def sa komand.",
      "back_to_cart": "Dellu ci paañe bi",
      "continue_to_payment": "Dem ci fey bi",
      "errors": {
        "name_required": "Tur bu mat mooy laaj",
        "name_too_short": "Tur war na am 3 araf lu ëpp",
        "phone_required": "Limeroo telefoon mooy laaj",
        "phone_invalid": "Limeroo senegaale jaaduwul (misaal: 77 123 45 67)",
        "address_required": "Adres mooy laaj",
        "address_too_short": "Adres war na am 10 araf lu ëpp",
        "commune_required": "Zone indil mooy laaj",
        "zone_required": "Tànnal zone indil",
        "method_unavailable": "Amul moom indil ci zone bii",
        "privacy_required": "War nga nangu politique kaaraange gi"
      },
      "validation_summary": {
        "title": "Jëkkalal njumte yii ngir dem kanam"
      },
      "address_form": {
        "title": "Adres indil",
        "full_name": "Tur bu mat",
        "full_name_placeholder": "Abdou Diallo",
        "phone": "Telefon",
        "phone_placeholder": "77 123 45 67",
        "address": "Adres bu mat",
        "address_placeholder": "Nimero, mbedd, kër",
        "commune": "Zone indil",
        "commune_placeholder": "Seet sa zone...",
        "email": "E-mail (bu soxor)",
        "email_placeholder": "samail@yaw.com",
        "gps_button": "Xam sa bëkkëram",
        "gps_denied": "Tann sa ndakaaru ci liste bi",
        "privacy_prefix": "Dëgg naa",
        "privacy_link": "règles yi ñu ko seet",
        "privacy_suffix": "yi Djayma"
      },
      "method": {
        "title": "Yoonu indil",
        "standard": "Indil bu dëkk",
        "express": "Indil bu gaaw"
      },
      "map": {
        "unavailable": "Carte du waxte bi amul",
        "load_error": "Carte bi dëkkul am",
        "your_position": "Sa bëkkëram",
        "drag_instruction": "Yóbbul pin bi ngir xam sa wëkker bu baax"
      },
      "summary": {
        "items_count": "{{count}} produwe",
        "items_count_plural": "{{count}} produwe",
        "subtotal_label": "Tollu :",
        "subtotal_ht": "Tollu HT",
        "tva": "TVA (18 %)",
        "delivery_fee": "Njëg indil",
        "service_fee": "Njëg sërvisu",
        "free": "Yomb",
        "free_delivery_threshold": "Indil yomb ci {{amount}}",
        "total_ttc": "Tollu TTC"
      }
    },

    "whatsapp": {
      "confirm_cta": "Dëgël ci WhatsApp",
      "payment_instruction": "Yónneel",
      "payment_to": "ci CIEDA {{provider}} nimeero bi",
      "copy_number": "Jëfandikool nimeero bi",
      "copied": "Jëfandikool na!",
      "merchant_number_unavailable": "Nimeero paiement CIEDA bi mu gën. Woteel nu ci +221 76 604 22 74 ngir xalaat sa commande bi.",
      "next_steps_title": "Étapes yi",
      "step_pay": "Yónneel jënd bi ci {{provider}}",
      "step_confirm": "Dëgëlël na ley ñëw ak 2h",
      "step_deliver": "Dugal ci sa ndakaaru",
      "reopen_whatsapp": "Ubbi WhatsApp rekk",
      "order_received": "Commande bi def na!"
    }
  },

  "tracking": {
    "title": "Topp komand bi",
    "subtitle": "Dugal sa référence komand ngir topp sa indil.",
    "reference_placeholder": "Misaal : CMD-20260215-0042",
    "search": "Seet",
    "reference_label": "Référence komand",
    "ordered_on": "Def na komand ci",
    "not_found": "Gisul komand bi. Xoolal référence bi te jéemal ko.",
    "estimated_delivery": "Indil bu ñëw :",
    "summary": "Tënk komand bi",
    "subtotal": "Tollu",
    "tax": "TVA (18 %)",
    "total": "Tollu TTC",
    "status_pending": "Yaa ngi xaar",
    "status_confirmed": "Dëgg na",
    "status_processing": "Ñuy prepare",
    "status_shipped": "Yónn nañu ko",
    "status_delivered": "Agsi na"
  }
}
